export const setThemeColor = () => {
    const lightColor = "#ffffff"
    const darkColor = "#171717"
    const metaThemeColor = document.querySelector('meta[name="theme-color"]')

    const prefersDarkMode = getPrefersDarkMode()

    metaThemeColor?.setAttribute(
        "content",
        prefersDarkMode ? darkColor : lightColor,
    )
    if (prefersDarkMode) {
        document.documentElement.classList.add("dark")
    } else {
        document.documentElement.classList.remove("dark")
    }
}

export const getPrefersDarkMode = () => {
    const savedMode = localStorage.getItem("darkMode")
    const prefersDarkMode = JSON.parse(savedMode) || false
    return prefersDarkMode
}
